"use strict";

var _require = require('@polydice/icook-devise-unify'),
    getOriginByURL = _require.getOriginByURL,
    deviseSignIn = _require.deviseSignIn,
    deviseSignUp = _require.deviseSignUp,
    deviseLogout = _require.deviseLogout;

var Cookie = require('js-cookie');

document.querySelectorAll('.devise-signin').forEach(function (element) {
  element.addEventListener('click', function (event) {
    event.preventDefault();
    var _window$location = window.location,
        origin = _window$location.origin,
        pathname = _window$location.pathname;
    deviseSignIn({
      entry: "".concat(getOriginByURL("".concat(origin).concat(pathname)), "_header"),
      redirect: "".concat(origin).concat(pathname)
    });
  });
});
document.querySelectorAll('.devise-signup').forEach(function (element) {
  element.addEventListener('click', function (event) {
    event.preventDefault();
    var _window$location2 = window.location,
        origin = _window$location2.origin,
        pathname = _window$location2.pathname;
    deviseSignUp("".concat(origin).concat(pathname));
  });
});
document.querySelectorAll('.devise-logout').forEach(function (element) {
  element.addEventListener('click', function (event) {
    event.preventDefault();
    var _window$location3 = window.location,
        origin = _window$location3.origin,
        pathname = _window$location3.pathname;
    deviseLogout("".concat(origin).concat(pathname));
  });
});
document.querySelectorAll('.global-navbar-download-button').forEach(function (element) {
  element.addEventListener('click', function (event) {
    event.preventDefault();
    window.dataLayer = window.dataLayer || [];

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.dataLayer.push({
        event: 'header_btn'
      });
      var nowHref = window.location.href;
      window.location.href = 'https://icook.onelink.me/Dl1H/t9t43s87?deep_link_value=' + encodeURIComponent(nowHref);
      return;
    }

    var scrollPosition = window.scrollY;
    var popupMask = document.querySelector('.global-download-app-cta-mask');
    var popupContainer = document.querySelector('.global-download-app-cta-container');
    if (!popupMask || !popupContainer) return;
    popupMask.classList.add('global-download-app-cta-mask-show');
    popupContainer.classList.add('global-download-app-cta-container-show');
    document.body.style.position = 'fixed';
    document.body.style.top = "-".concat(scrollPosition, "px");
    document.body.style.width = '100%';
    window.dataLayer.push({
      event: 'click_desktop_header_app_cta'
    });
  });
});
window.addEventListener('load', function () {
  var have_unread = Cookie.get('have_unread');

  if (have_unread === 'true') {
    document.querySelectorAll('.dashboard-notification').forEach(function (element) {
      element.classList.add('active');
    });
  }
});